import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSearchText } from "../../features/project/projectSlice";

// debounce
const debounce = (fn, delay) => {
    let time;
    return (...args) => {
        if (time) {
            clearTimeout(time);
        }
        time = setTimeout(() => {
            fn(...args);
        }, delay);
    };
};

export default function Search() {
    // get search data
    const { search } = useSelector((state) => state.project);
    const [txt, setTxt] = useState(search);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(addSearchText(txt));
    }, [dispatch, txt]);

    return (
        <>
            <input
                className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
                type="search"
                placeholder="Search for anything…"
                onChange={debounce((e) => setTxt(e.target.value), 600)}
                required
            />
        </>
    );
}
